import { checkIsExtension, getFetchParams } from "./helpers/helpers";
/**
 * make request and return data without additional logic attched like 401 error handling.
 */
export const baseFetchSimple = async (request) => {
    return checkIsExtension() ? baseFetchExtensionSimple(request) : baseFetchWebSimple(request);
};
const baseFetchExtensionSimple = async (request) => {
    const { url, body } = await getFetchParams(request);
    return new Promise((resolve, reject) => {
        chrome.runtime.sendMessage({ type: request.type, url, params: body }, async (response) => {
            try {
                resolve(response.data);
            }
            catch (error) {
                reject(error instanceof Error ? error : new Error(error));
            }
        });
    });
};
const baseFetchWebSimple = async (request) => {
    const { url, body } = await getFetchParams(request);
    const response = await fetch(url, body);
    const isJson = response.headers.get("Content-Type")?.includes("application/json");
    return await response[isJson ? "json" : "text"]();
};
